import { render, staticRenderFns } from "./WDialog.vue?vue&type=template&id=fdfa7f86&"
import script from "./WDialog.vue?vue&type=script&lang=ts&"
export * from "./WDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports